<template>
  <div
    class="d-signup-modal modal modal-sm sign-up-modal"
    :class="{ 'active': isShown }"
  >
    <div class="overlay" />
    <div
      class="modal-content"
    >
      <a
        class="button button-icon button-close button-close-modal"
        @click="hide()"
      />

      <div class="modal-image">
        <img :src="images.header">
      </div>
      <div class="modal-body">
        <DSignupModalSignup />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import DSignupModalSignup from './d-signup-modal-signup/d-signup-modal-signup.vue';

import GREAT_STORY_IMG from '@d-assets/great-story.svg';

export default {
  components: {
    DSignupModalSignup,
  },
  data: () => ({
    images: {
      header: GREAT_STORY_IMG,
    },
    isShown: false,
  }),
  methods: {
    hide() {
      this.$set(this, 'isShown', false);
    },

    show() {
      this.$set(this, 'isShown', true);
      Vue.prototype.eventsTracking.continueChain('open-sign-up-modal');
    },
  },
};
</script>
